import React from 'react';
import cs from 'classnames';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloseIcon from 'assets/images/close-icon.svg';
import ArchiveIcon from 'components/icons/Archive';
import UnarchiveIcon from 'components/icons/Unarchive';

const GlassBeadCard = ({ classes, onDelete, onArchive, onRestore, data, ...props }) => {
  const action = onArchive
    ? { Icon: ArchiveIcon, label: 'archive', onClick: onArchive }
    : onRestore && { Icon: UnarchiveIcon, label: 'restore', onClick: onRestore };

  return (
    <div className={classes.root} {...props}>
      <div className={classes.header}>
        <span className={cs(classes.title, { [classes.titleWithAction]: action && onDelete })}>{data.name}</span>
        {action && (
          <Button
            className={cs(classes.actionButton, { [classes.actionWithDelete]: onDelete })}
            aria-label={action.label}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              action.onClick(data);
            }}
            disableRipple
          >
            <action.Icon />
          </Button>
        )}
        {onDelete && (
          <Button
            color="secondary"
            className={classes.deleteButton}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete(data);
            }}
            disableRipple
          >
            <img src={CloseIcon} alt="delete" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(GlassBeadCard);
